const defaultErrorMessage = 'Just nu kan vi inte ändra dina uppgifter. Testa gärna igen om en stund.'

export default function (success, message) {
  return {
    success,
    message: message || defaultErrorMessage
  }
}
